const Header = ({ mode, action }) => {
  if (mode === 'modal') return null;
  return (
    <div className="p-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">
          {mode === 'principal' ? 'Interacciones' : 'Historial de actividades'}
        </h2>
        {action}
      </div>
      {mode === 'resume' && (
        <h3 className="text-xs text-gray-500">
          ¡Sigue sumando, sigue creciendo!
        </h3>
      )}
    </div>
  );
};

export default Header;
